import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, VFButton, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';

import styles from './WhyFirstBillModal.Styles';

const WhyFirstBillModal = ({
  titleKey,
  questionKey,
  descriptionKey,
  buttonKey,
  firstBill,
  isVisible,
  closeModal,
  onClosePress,
}) => {
  return (
    <QuickActionMenu
      isVisible={isVisible}
      title={titleKey}
      withCloseButton={false}
      titleStyle={styles.title}
      headerStyle={styles.header}
      type={'secondary'}
      closeModal={closeModal}
      toggleModal={() => {}}
    >
      <View>
        <VFText
          type={'primary'}
          style={styles.question}
          i18nKey={questionKey}
          placeHolders={[firstBill]}
        />

        <VFText type={'primary'} style={styles.contentText} i18nKey={descriptionKey} />
        <VFButton style={styles.button} title={buttonKey} onPress={onClosePress} />
      </View>
    </QuickActionMenu>
  );
};
WhyFirstBillModal.propTypes = {
  titleKey: PropTypes.string,
  questionKey: PropTypes.string,
  descriptionKey: PropTypes.string,
  buttonKey: PropTypes.string,
  firstBill: PropTypes.string,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  onClosePress: PropTypes.func,
};
export default WhyFirstBillModal;
